import React, {useContext} from 'react';
import { MDBContainer, MDBRow, MDBCard, MDBCardBody, MDBCol } from "mdb-react-ui-kit";
import { ThemeContext } from '../../../Context/ThemeContext';

const CardLayout = ({ children, title, logo='', customerLogo=false }) => {
    const { theme } = useContext(ThemeContext);
    return (
    <MDBContainer className="pt-2 mt-5">
        <MDBRow className="mt-3 d-flex justify-content-center mb-4">
            <div className="card-body text-center auth-logo mb-2">
                {theme === "dark" || theme === "high-contrast"
                    ? <img className="mb-3" src={customerLogo == false ? process.env.REACT_APP_WEB_URL + "pbs-logo-dark.svg" : logo} alt="logo" />
                    : <img className="mb-3" src={customerLogo == false ? process.env.REACT_APP_WEB_URL + "pbs-logo.svg" : logo} alt="logo" />
                }
            </div>
            <h5 className="card-body text-center auth-logo mb-2">{title}</h5>
            <MDBCol md="6" className="mb-4 mb-md-0 fixed-height mb-4 mt-4">
                <MDBCard className="h-100">
                    <MDBCardBody className="p-4">
                        {children}
                    </MDBCardBody>
                </MDBCard>
            </MDBCol>
        </MDBRow>
    </MDBContainer>
    );
};

export default CardLayout;
